import "./Assess.scss";
import React, { Component } from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { assessStore, resultStore, authStore } from "../stores";
import CurrentQuestion from "./CurrentQuestion";
import QuestionProgress from "./QuestionProgress";
import AssessBackground from "./AssessBackground";
import AssessDone from "./AssessDone";
import AssessIntro from "./AssessIntro";
import { Button, IonIcon, KeyListener } from "../lib";
import { ASSESS_TYPE_LEADER } from "./../constants";

class Assess extends Component {
  componentWillMount() {
    assessStore.init(this.props.match.params.type);
  }

  componentDidMount() {
    if (window.fbq) {
      window.fbq("track", "ViewContent");
    }
  }

  render() {
    if (!authStore.auth && assessStore.type === ASSESS_TYPE_LEADER) {
      return <Redirect to="/signin" />;
    }
    if (assessStore.completed) {
      return <Redirect to="/submit" />;
    }
    if (!assessStore.current) {
      return null;
    }
    if (resultStore.responses) {
      return <AssessDone />;
    }
    const started = assessStore.progress > 0 || assessStore.started;
    return (
      <div className="Assess">
        <AssessBackground progress={assessStore.progress} />
        <div className="Assess_wrapper">
          {assessStore.inviteChurch && (
            <div className="Assess_invite">
              <h5>{assessStore.inviteChurch}</h5>
              <span>Invited by {assessStore.inviteEmail}</span>
            </div>
          )}
          {!started && <AssessIntro />}
          {started && (
            <div className="Assess_questions">
              <CurrentQuestion
                key={assessStore.current.id}
                question={assessStore.current}
                answered={assessStore.answered}
                onAnswer={assessStore.answer}
                onNext={assessStore.forward}
              />
              <div className="Assess_controls">
                <Button
                  styleType="blank"
                  onClick={assessStore.back}
                  disabled={!assessStore.prev}
                >
                  <IonIcon icon="android-arrow-back" />
                </Button>
                <Button
                  onClick={assessStore.forward}
                  disabled={assessStore.forwarding || !assessStore.answered}
                >
                  <div>
                    Next<span>Press Enter</span>
                  </div>
                </Button>
              </div>
              {assessStore.answered && (
                <KeyListener onEnter={assessStore.forward} />
              )}
            </div>
          )}
          <QuestionProgress progress={assessStore.progress} />
        </div>
      </div>
    );
  }
}

Assess.displayName = "Assess";

export default observer(Assess);



// WEBPACK FOOTER //
// ./src/assess/Assess.js